/* mt-search.js — Mari Time leitarlag fyrir Prestige (Klukkan + Móri), 13.9.2026
 * - Samheiti/beygingar: endurskrifar leitarorð áður en þau fara í Shopify predictive search og /search
 * - Varaleit: ef Shopify skilar engu er reynt að leiðrétta stafsetningu (orðaforði búðarinnar) og vörunúmer án bandstrika
 * - Vísitala: assets/mt-search-index.json (búin til daglega úr vörulista)
 */
(function () {
  'use strict';
  if (window.__mtSearch) return;
  var cfg = window.__mtSearchConfig || {};
  var INDEX_URL = cfg.indexUrl;
  if (!INDEX_URL) return;
  var index = null, loading = null;

  var MAP = { 'á':'a','é':'e','í':'i','ó':'o','ú':'u','ý':'y','ö':'o','æ':'ae','ð':'d','þ':'th','à':'a','è':'e','ä':'a','ü':'u','ø':'o','å':'a' };
  function norm(s) {
    s = String(s || '').toLowerCase();
    var out = '';
    for (var i = 0; i < s.length; i++) { var c = s[i]; out += MAP[c] !== undefined ? MAP[c] : c; }
    return out.replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function alnum(s) { return norm(s).replace(/\s+/g, ''); }

  function load() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    loading = fetch(INDEX_URL, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (j) {
      j._words = (j.words || []).map(function (w) { return { w: w[0], n: norm(w[0]), f: w[1] || 1 }; });
      j._skus = (j.skus || []).map(function (s) { return { n: alnum(s), o: s }; });
      j._syn = {}; Object.keys(j.syn || {}).forEach(function (k) { j._syn[norm(k)] = j.syn[k]; });
      index = j; return j;
    }).catch(function () { index = { _words: [], _skus: [], _syn: {} }; return index; });
    return loading;
  }

  // Damerau-Levenshtein með snemmbúnu hámarki
  function dist(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev = [], cur = [], prev2 = [];
    for (var j = 0; j <= lb; j++) prev[j] = j;
    for (var i = 1; i <= la; i++) {
      cur[0] = i; var rowMin = i;
      for (var jj = 1; jj <= lb; jj++) {
        var cost = a[i - 1] === b[jj - 1] ? 0 : 1;
        var v = Math.min(prev[jj] + 1, cur[jj - 1] + 1, prev[jj - 1] + cost);
        if (i > 1 && jj > 1 && a[i - 1] === b[jj - 2] && a[i - 2] === b[jj - 1]) v = Math.min(v, prev2[jj - 2] + 1);
        cur[jj] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur; cur = [];
    }
    return prev[lb];
  }

  function applySynonyms(q, idx) {
    var words = q.split(/\s+/).filter(Boolean);
    var full = idx._syn[norm(q)];
    if (full) return full;
    var changed = false;
    var out = words.map(function (w) { var s = idx._syn[norm(w)]; if (s) { changed = true; return s; } return w; });
    return changed ? out.join(' ') : q;
  }

  function correctWord(w, idx) {
    var n = norm(w); if (n.length < 3) return null;
    var max = n.length >= 7 ? 2 : (n.length >= 4 ? 1 : 0);
    var best = null, bestScore = 1e9;
    for (var i = 0; i < idx._words.length; i++) {
      var e = idx._words[i];
      if (e.n === n) return null; // þegar rétt
      if (e.n.length < 3) continue;
      var d;
      if (n.length >= 4 && e.n.indexOf(n) === 0) d = 0.5; // forskeyti
      else { if (max === 0) continue; d = dist(n, e.n, max); if (d > max) continue; }
      var score = d * 1000 - Math.min(e.f, 500) + (e.n[0] === n[0] ? 0 : 200);
      if (score < bestScore) { bestScore = score; best = e; }
    }
    return best ? best.w : null;
  }

  function correctQuery(q, idx) {
    var words = q.split(/\s+/).filter(Boolean), changed = false;
    var out = words.map(function (w) { if (/\d/.test(w)) return w; var c = correctWord(w, idx); if (c && norm(c) !== norm(w)) { changed = true; return c; } return w; });
    return changed ? out.join(' ') : null;
  }

  function skuQuery(q, idx) {
    var n = alnum(q); if (n.length < 4 || !/\d/.test(n)) return null;
    var hit = null;
    for (var i = 0; i < idx._skus.length; i++) { if (idx._skus[i].n.indexOf(n) === 0) { hit = idx._skus[i]; break; } }
    if (!hit) for (var k = 0; k < idx._skus.length; k++) { if (idx._skus[k].n.indexOf(n) > 0) { hit = idx._skus[k]; break; } }
    if (!hit) return null;
    // klippa upprunalega strenginn við sömu lengd (bandstrik haldast)
    var start = hit.n.indexOf(n), o = hit.o, count = 0, from = -1, to = o.length;
    for (var p = 0; p < o.length; p++) {
      if (/[a-z0-9]/i.test(o[p]) || MAP[o[p].toLowerCase()]) { if (count === start && from < 0) from = p; count++; if (count === start + n.length) { to = p + 1; break; } }
    }
    return o.slice(Math.max(from, 0), to);
  }

  // Skilar { q: nýtt leitarorð, why: 'syn'|'spell'|'sku' } eða null
  function suggest(q, idx, skipSyn) {
    if (!skipSyn) { var s = applySynonyms(q, idx); if (s !== q) return { q: s, why: 'syn' }; }
    var k = skuQuery(q, idx); if (k && k.toLowerCase() !== q.trim().toLowerCase()) return { q: k, why: 'sku' };
    var c = correctQuery(q, idx); if (c) return { q: c, why: 'spell' };
    return null;
  }

  // ---------- Predictive search (header) ----------
  var origFetch = window.fetch;
  function isSuggest(url) { return /\/search\/suggest(\?|$)/.test(url); }
  function setQ(url, q) { var u = new URL(url, location.origin); u.searchParams.set('q', q); return u.toString(); }
  function hasResults(html) { return html.indexOf('predictive-search__no-results') < 0 && /predictive-search__results/.test(html); }
  function note(html, orig, used, why) {
    var label = why === 'sku' ? 'Fann vörunúmer: ' : 'Sýni niðurstöður fyrir ';
    var n = '<p class="mt-search-note text-sm text-subdued" style="margin:0 0 .75rem">' + label + '<strong>' + esc(used) + '</strong> (leitað var að „' + esc(orig) + '“)</p>';
    return html.replace(/(<div class="predictive-search__results[^"]*">)/, '$1' + n);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ---------- Flokkar (flýtihnappar) úr vísitölunni: aðalflokkur fremst ----------
  // gróf íslensk stofnun fyrir flokka-samanburð: o→a jafnar u-hljóðvarp (armband/armbönd, gjöf/gjafir, svart/svört)
  function stem(s) { return norm(s).replace(/o/g, 'a'); }
  function chipsFor(qs, idx) {
    var seen = {}, list = [];
    qs.forEach(function (q) {
      var n = stem(q); if (n.length < 2) return;
      (idx.colls || []).forEach(function (c) {
        var t = stem(c[0]); if (!t || seen[c[1]]) return;
        var rank = -1;
        if (t === n) rank = 0;
        else if (n.length >= 4 && t.indexOf(n) === 0) rank = 1;
        else if ((' ' + t + ' ').indexOf(' ' + n + ' ') >= 0) rank = 2;
        else if (n.length >= 4 && (' ' + t).indexOf(' ' + n) >= 0) rank = 2;
        else if (n.length >= 5 && t.indexOf(n) >= 0) rank = 3;
        if (rank < 0) return;
        seen[c[1]] = 1; list.push({ r: rank, l: t.length, t: c[0], h: c[1] });
      });
    });
    list.sort(function (a, b) { return a.r - b.r || a.l - b.l; });
    return list.slice(0, 5);
  }
  function chipsHtml(items) {
    if (!items.length) return '';
    return '<div class="predictive-search__resource-item mt-quick-links"><div class="v-stack gap-4"><p class="predictive-search__category h6 text-subdued">Flokkar</p><div class="mt-quick-links__row">' +
      items.map(function (c) { return '<a href="/collections/' + esc(c.h) + '" class="mt-quick-link" data-instant>' + esc(c.t) + '</a>'; }).join('') + '</div></div></div>';
  }
  (function () { var st = document.createElement('style'); st.textContent = '.mt-quick-links__row{display:flex;flex-wrap:wrap;gap:.5rem}.mt-quick-link{display:inline-block;padding:.45rem .9rem;border:1px solid rgb(var(--text-color) / .25);border-radius:999px;font-size:.875rem;line-height:1.2;text-decoration:none}.mt-quick-link:hover{background:rgb(var(--text-color));color:rgb(var(--background))}.mt-quick-links{margin-bottom:.5rem}.mt-search-note{margin:0 0 .75rem}.predictive-search__results:has(.mt-quick-links) .predictive-search__tabs{grid-column:1/-1}'; document.head.appendChild(st); })();
  function injectChips(html, qs, idx) {
    var items = chipsFor(qs, idx);
    // fjarlægja Liquid-útgáfuna (varaleið) og setja okkar í staðinn
    html = html.replace(/<div class="predictive-search__resource-item mt-quick-links">[\s\S]*?<\/div>\s*<\/div>\s*<\/div>/, '');
    if (!items.length) return html;
    var block = chipsHtml(items);
    if (/<div class="predictive-search__results[^"]*">/.test(html)) return html.replace(/(<div class="predictive-search__results[^"]*">(?:\s*<p class="mt-search-note[\s\S]*?<\/p>)?)/, '$1' + block);
    if (html.indexOf('predictive-search__no-results') >= 0) return html.replace(/(<p class="predictive-search__no-results)/, '<div class="predictive-search__results">' + block + '</div>$1');
    return html;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isSuggest(url)) return origFetch.apply(this, arguments);
    var q = new URL(url, location.origin).searchParams.get('q') || '';
    if (q.trim().length < 2) return origFetch.apply(this, arguments);
    var self = this, args = arguments;
    return load().then(function (idx) {
      var syn = applySynonyms(q, idx), first = syn !== q ? setQ(url, syn) : url;
      var out = function (html, res, used, why) {
        if (used && used !== q) html = note(html, q, used, why);
        html = injectChips(html, used && used !== q ? [q, used] : [q], idx);
        return new Response(html, res);
      };
      return origFetch.call(self, first, init).then(function (res) {
        if (!res.ok) return res;
        return res.clone().text().then(function (html) {
          if (hasResults(html)) return out(html, res, syn, 'syn');
          var alt = suggest(q, idx, true); // sku / stafsetning
          if (!alt) return out(html, res);
          return origFetch.call(self, setQ(url, alt.q), init).then(function (res2) {
            if (!res2.ok) return out(html, res);
            return res2.text().then(function (html2) { return hasResults(html2) ? out(html2, res2, alt.q, alt.why) : out(html, res); });
          });
        });
      });
    });
  };

  // hita vísitöluna þegar leitarreitur fær fókus
  document.addEventListener('focusin', function (e) { if (e.target && e.target.matches && e.target.matches('input[type="search"], input[name="q"]')) load(); });

  // ---------- Leitarsíða (/search) ----------
  function onSearchPage() {
    var el = document.querySelector('[data-mt-search-empty]'); if (!el) return;
    var q = el.getAttribute('data-q') || ''; if (!q) return;
    var params = new URLSearchParams(location.search);
    if (params.get('mt_from')) return; // þegar búið að leiðrétta einu sinni
    load().then(function (idx) {
      var alt = suggest(q, idx, false); if (!alt) return;
      // athuga hvort leiðréttingin skili einhverju áður en við sendum notandann áfram
      origFetch('/search/suggest?q=' + encodeURIComponent(alt.q) + '&section_id=predictive-search&resources[type]=product,collection').then(function (r) { return r.text(); }).then(function (html) {
        if (!hasResults(html)) return;
        var u = new URL(location.href); u.searchParams.set('q', alt.q); u.searchParams.set('mt_from', q); location.replace(u.toString());
      });
    });
  }
  function onSearchNote() {
    var from = new URLSearchParams(location.search).get('mt_from'); if (!from) return;
    var h = document.querySelector('.main-search, .empty-state'); if (!h) return;
    var p = document.createElement('p'); p.className = 'mt-search-note text-subdued'; p.style.textAlign = 'center'; p.style.margin = '0 0 1.5rem';
    p.innerHTML = 'Engar niðurstöður fyrir „' + esc(from) + '“ – sýni í staðinn niðurstöður fyrir <strong>' + esc(new URLSearchParams(location.search).get('q') || '') + '</strong>.';
    h.parentNode.insertBefore(p, h);
  }
  // flokka-flýtihnappar efst á leitarsíðunni (/search?q=…)
  function onSearchChips() {
    if (location.pathname.indexOf('/search') !== 0) return;
    var q = new URLSearchParams(location.search).get('q'); if (!q) return;
    var from = new URLSearchParams(location.search).get('mt_from');
    var host = document.querySelector('.main-search') || document.querySelector('.empty-state'); if (!host) return;
    load().then(function (idx) {
      var items = chipsFor(from ? [from, q] : [q], idx); if (!items.length) return;
      // leitarorð sem er nákvæmlega heiti flokks (t.d. „herraúr“) → beint í flokkinn
      if (items[0].r === 0 && !from && !/\d/.test(q)) { location.replace('/collections/' + items[0].h); return; }
      var wrap = document.createElement('div'); wrap.className = 'mt-search-page-chips'; wrap.style.cssText = 'margin:0 0 1.5rem;display:flex;flex-wrap:wrap;gap:.5rem;align-items:center;justify-content:center';
      wrap.innerHTML = '<span class="text-subdued text-sm" style="margin-right:.25rem">Flokkar:</span>' + items.map(function (c) { return '<a href="/collections/' + esc(c.h) + '" class="mt-quick-link">' + esc(c.t) + '</a>'; }).join('');
      host.parentNode.insertBefore(wrap, host);
    });
  }
  // samheiti á formsendingu (aðal-leitarform)
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[action*="/search"]')) return;
    var inp = f.querySelector('input[name="q"]'); if (!inp || !index) return;
    var s = applySynonyms(inp.value, index); if (s !== inp.value) inp.value = s;
  }, true);

  function initPage() { onSearchPage(); onSearchNote(); onSearchChips(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage);
  else initPage();

  window.__mtSearch = { norm: norm, suggest: function (q) { return load().then(function (i) { return suggest(q, i, false); }); }, load: load };
})();
